"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ChatMessage_1 = __importDefault(require("./Entity/ChatMessage"));
var ChatMessageApi = /** @class */ (function () {
    function ChatMessageApi(session) {
        this.chatMessageEntity = new ChatMessage_1.default(session);
        this.onItemCreated = this.chatMessageEntity.store.onItemCreated;
        this.onListUpdate = this.chatMessageEntity.onChatMessagesUpdate;
    }
    ChatMessageApi.prototype.fetchMessages = function (request) {
        return this.chatMessageEntity.fetchMessages(request);
    };
    ChatMessageApi.prototype.getChatMessages = function (id) {
        return this.chatMessageEntity.getChatMessages(id);
    };
    ChatMessageApi.prototype.createMessages = function (requests) {
        return this.chatMessageEntity.createMessages(requests);
    };
    return ChatMessageApi;
}());
exports.default = ChatMessageApi;
//# sourceMappingURL=ChatMessageApi.js.map